/* KOG — JELUZ product page behaviour.
   Keeps Shopify's native variant / cart mechanics: we only mirror the state
   into the CTA label and the mobile sticky bar. */
(function () {
  var cta = document.querySelector('[data-kog-cta]');
  var sticky = document.querySelector('[data-kog-sticky]');
  if (!cta) return;

  /* --- Sticky bar visibility: shown once the main CTA has left the viewport --- */
   if (sticky && 'IntersectionObserver' in window) {
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting) sticky.removeAttribute('data-visible');
      else sticky.setAttribute('data-visible', '');
    }, { threshold: 0.4 }).observe(cta);
  }

  /* --- "Size guide" link opens the size-guide accordion and scrolls to it --- */
  var guideBtn = document.querySelector('[data-kog-open-size-guide]');
  var guide = document.querySelector('[data-kog-size-guide]');
  if (guideBtn && guide) {
    guideBtn.addEventListener('click', function () {
      guide.open = true;
      var top = guide.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* --- Mirror the selected variant into CTA + sticky bar ---
     Reads Shopify's variant JSON so price / availability stay authoritative. */
  var section = cta.closest('.shopify-section') || document;
 var json = section.querySelector('[data-kog-variants]') ||
             section.querySelector('[type="application/json"][id^="ProductJSON"], script[data-product-json]');
  var variants = null;
  try {
    var parsed = json ? JSON.parse(json.textContent) : null;
    variants = parsed && parsed.variants ? parsed.variants : parsed;
  } catch (err) { variants = null; }

function legacyMoney(cents) {
    var f = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: f
    }).format(cents / 100);
  }

  function selectedValues() {
    var picked = {};
    Array.prototype.forEach.call(
      section.querySelectorAll('[data-kog-input]:checked'),
      function (i, order) {
        var idx = i.getAttribute('data-kog-opt');
        picked[idx === null ? order : Number(idx)] = i.value;
      }
    );
    return picked;
  }

  function sync() {
    var picked = selectedValues();
    var keys = Object.keys(picked);
    var sizeEl = document.querySelector('[data-kog-sticky-size]');
    if (sizeEl && keys.length) {
      sizeEl.textContent = keys.map(function (k) { return picked[k]; }).join(' / ');
    }

    if (!variants || !variants.length || !keys.length) return;
    var match = variants.filter(function (v) {
      if (!v.options) return false;
      return keys.every(function (k) { return v.options[k] === picked[k]; });
    })[0];
    if (!match) return;

    var idInput = section.querySelector('[data-kog-variant-id]');
    if (idInput) idInput.value = match.id;
  if (!cta.dataset.kogLabel) cta.dataset.kogLabel = cta.textContent;
    cta.disabled = !match.available;
    cta.textContent = match.available ? cta.dataset.kogLabel : 'Sold out';
  }

  section.addEventListener('change', function (e) {
    if (e.target.matches('[data-kog-input]')) sync();
  });
  sync();
})();

/* KOG — Zoom galerie + size guide */
(function () {
  var box = document.querySelector('[data-kog-zoom]');
  if (!box) return;
  var img = box.querySelector('[data-kog-zoom-img]');

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    box.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    box.hidden = true;
    img.src = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('.product__media img, .kog-guide__item img, .kog-rte img');
    if (!target) return;
    e.preventDefault();
    var src = target.currentSrc || target.src;
    open(src.replace(/(\?|&)width=\d+/, '$1width=2000'), target.alt);
  });

  box.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
})();
(function () {
  var group = document.querySelector('.kog-swatches--color');
  if (!group) return;
  var inputs = group.parentNode.querySelectorAll('[data-kog-input]');
  if (!inputs.length) return;
  var colors = Array.prototype.map.call(inputs, function (i) {
    return i.value.trim().toLowerCase();
  });
  var media = document.querySelectorAll('.product__media-item');
  var thumbs = document.querySelectorAll('.thumbnail-list__item');
  if (!media.length) return;

  function ownerOf(el) {
    var img = el.querySelector('img');
    var alt = img ? (img.alt || '').toLowerCase() : '';
    for (var i = 0; i < colors.length; i++) {
      if (alt.indexOf(colors[i]) !== -1) return colors[i];
    }
    return null;
  }
  var owners = Array.prototype.map.call(media, ownerOf);
  if (!owners.some(function (o) { return o !== null; })) return;

  function tid(t) {
    var btn = t.querySelector('[data-target], button, a');
    return t.getAttribute('data-target') ||
           (btn && (btn.getAttribute('data-target') || btn.getAttribute('data-media-id')));
  }

  function apply() {
    var picked = null;
    Array.prototype.forEach.call(inputs, function (i) {
      if (i.checked) picked = i.value.trim().toLowerCase();
    });
    if (!picked) return;
    var first = null;
    Array.prototype.forEach.call(media, function (el, idx) {
      var show = owners[idx] === null || owners[idx] === picked;
      el.style.display = show ? '' : 'none';
      if (show && first === null) first = idx;
      var id = el.getAttribute('data-media-id');
      Array.prototype.forEach.call(thumbs, function (t) {
        var x = tid(t);
        if (id && x && x.indexOf(id) !== -1) t.style.display = show ? '' : 'none';
      });
    });
    if (first !== null) {
      var visible = 0;
      Array.prototype.forEach.call(media, function (el) {
        if (el.style.display !== 'none') visible++;
      });
      var rail = document.querySelector('.thumbnail-slider, .thumbnail-list');
      if (rail) {
        var host = rail.closest('slider-component') || rail;
        host.style.display = visible > 1 ? '' : 'none';
      }
      var target = media[first].getAttribute('data-media-id');
      Array.prototype.forEach.call(thumbs, function (t) {
        if (t.style.display === 'none') return;
        var x = tid(t);
        var btn = t.querySelector('[data-target], button, a');
        if (target && x && x.indexOf(target) !== -1 && btn) btn.click();
      });
    }
  }
  group.parentNode.addEventListener('change', function (e) {
    if (e.target.matches('[data-kog-input]')) apply();
  });
  apply();
})();/* KOG — Combinaisons de variantes inexistantes */
(function () {
  var cache = null;

  function data() {
    if (cache) return cache;
    var n = document.querySelector('[data-kog-variants]');
    if (!n) return null;
    try { cache = JSON.parse(n.textContent); } catch (e) { return null; }
    return cache.length ? cache : null;
  }

  function pos(i) { return Number(i.getAttribute('data-kog-opt')); }

  function find(list, combo) {
    for (var n = 0; n < list.length; n++) {
      var ok = true;
      for (var k = 0; k < combo.length; k++) {
        if (combo[k] != null && list[n].options[k] !== combo[k]) { ok = false; break; }
      }
      if (ok) return list[n];
    }
    return null;
  }

  function apply() {
    var list = data();
    if (!list) return;
    var ins = [].slice.call(document.querySelectorAll('[data-kog-input]'));
    if (!ins.length) return;

    var sel = [];
    ins.forEach(function (i) { if (i.checked) sel[pos(i)] = i.value; });

    ins.forEach(function (i) {
      var probe = sel.slice();
      probe[pos(i)] = i.value;
      var ok = !!find(list, probe);
      i.disabled = !ok;
      var l = i.closest('label');
      if (l) l.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });

    var m = find(list, sel);
    var h = document.querySelector('[data-kog-variant-id]');
    if (h) h.value = m ? m.id : '';

    [].slice.call(document.querySelectorAll('[data-kog-cta],[data-kog-add],[data-kog-sticky-cta]'))
      .forEach(function (b) {
        if (!m) { b.disabled = true; if (!b.hasAttribute('aria-label')) b.textContent = 'Unavailable combination'; }
      });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-kog-input]')) apply();
  });
  window.addEventListener('load', apply);
  apply();
})();